import { Injectable } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { PortfoliosComponent } from '@irb/irb-clients/portfolios/portfolios.component';
import { IDropdownItem } from '@irb/irb-common/models/dropdown.model';
import { DropdownFilterRendererComponent } from '@irb/irb-common/components/grid/renderers/dropdown-filter.cell.component';
import { DropdownSearchMultipleRendererComponent } from '@irb-common/components/grid/renderers/dropdown-search-multiple.cell.component';
import {CustomfilterComponent} from './customfilter/customfilter.component';
import {CustomEditorComponent} from './custom-editor/custom-editor.component';
import {IrbAgSetColumnFilterComponent} from '@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component';
import {IrbAgSingleSelectColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-single-select-column-filter/irb-ag-single-select-column-filter.component";
import {IrbClientsEvents, IrbSettingsEvents} from '@irb-common/events';
import { AppService } from '@irb/app.service';
import {SettingsPortfoliosComponent} from "@irb/irb-settings/settings-portfolios/settings-portfolios.component";
import {PortfolioLabelsService} from '@irb/irb-clients/portfolios/portfolios.labels.service';
import {AutomatedRendererComponent} from "@irb/irb-clients/portfolios/automated-renderer.component";

@Injectable({
    providedIn: 'root'
})
export class PortfoliosGridLayoutService implements GridLayoutService<PortfoliosComponent> {
    modelNames: any = [];

    constructor(private as: AppService, private pls: PortfolioLabelsService, private decp: DecimalPipe) {}

    getFrameworkComponents() {
        return {
            "DropdownFilterRendererComponent": DropdownFilterRendererComponent,
            "DropdownSearchMultipleRendererComponent": DropdownSearchMultipleRendererComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "customeditor": CustomEditorComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
            "IrbAgSingleSelectColumnFilterComponent": IrbAgSingleSelectColumnFilterComponent
        };
    }

    getColumnDefs(parent: PortfoliosComponent): any {
        let ret: any[] = [{
              headerName: 'Select All',
              headerComponent: 'customHeader',
              cellRenderer: 'customHeader',
              cellRendererParams: {parentObject: parent, type: 'rowCheckBox'},
              suppressColumnsToolPanel: true,
              suppressFiltersToolPanel: true,
              suppressSizeToFit: true,
              toolPanelClass: 'toolpanel-header-checkbox-hide',
              headerComponentParams: {parentObject: parent, type: 'headerCheckBox'},
              floatingFilterComponent: 'customHeader',
              floatingFilterComponentParams: {parentObject: parent, type: 'NoClearAllBtn'},
              suppressFloatingFilterButton: true,
              pinned: 'left',
              suppressMovable: true,
              lockPosition: true,
              lockVisible: true,
              sortable: false,
              filter: true,
              resizable: true,
              minWidth: 24,
              width: 24,
              maxWidth:24,
              cellStyle: {'padding': '5px 3px 0 2px'},
              headerClass: 'customHeaderClassSelectAll',
              cellClass: 'selectAllCheckBoxRecord'
            },
            {
              headerName: 'Name',
              field: 'portfolioName',
              sort: 'asc',
              suppressFiltersToolPanel: true,
              tooltipValueGetter: (params: any) => params.data ? params.data.portfolioName.colWidth < params.data.portfolioName.scrollWidth ? params.data.portfolioName : null : null,
              filter: 'agTextColumnFilter',
              suppressFloatingFilterButton: true,
              cellClass: 'nav-link-text',
              filterParams: {
                  clearButton: true,
                  debounceMs: 1000,
                  textFormatter: this.portfolioFilterFormatter,
                  maxNumConditions: 1,
                  values: (params: any) => {
                  params.success(parent.modelNames);
                  }
              },
              pinned: 'left',
              suppressMovable: true,
              lockPosition: true,
              lockVisible: true,
              cellClassRules: {
                  'add-pointer': (params: any) => {
                  return (params.value != null && params.value.length > 0);
                  }
              },
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {
                  link: (params: any) => {
                  return (params.value != null && params.value.length > 0);
                  },
      
                  onClick: (function (data: any) {
                  parent.ats.trackClickEvent("md_portname");
                  this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data});
                  }).bind(this)
              },
              minWidth: 140
            },
            {
              headerName: 'Status',
              headerComponentParams: {
                  irbColInfo: this.statusColInfo()
              },
              minWidth: 80,
              maxWidth: 115,
              field: 'status',
              suppressFiltersToolPanel: true,
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'IrbAgSingleSelectColumnFilterComponent',
              filterParams: {
                  values: [{label: 'Complete', value: 'Complete'}, {
                  label: 'Incomplete',
                  value: 'Incomplete'
                  }, {label: 'Unauthorized', value: 'Unauthorized'}],
                  buttons: ['reset'],
                  newRowsAction: 'keep',
                  suppressSorting: true,
                  cellHeight: 30
              },
              suppressFloatingFilterButton: false,
              sortable: false,
              cellRendererSelector: (params: any) => {
                  let finalValue;
                  if (params.data) {
                  if (params.data.status === 'incomplete' || params.data.status === 'Unauthorized') {
                      finalValue = 'Incomplete';
                  } else if (params.data.authStatus === 'Unauthorized') {
                      finalValue = 'Unauthorized';
                  } else {
                      if (params.data.acctQty === 0 || params.data.securityModelId === null || params.data.securityModelId === '') {
                      finalValue = 'Incomplete';
                      } else {
                      finalValue = '';
                      }
                  }
                  }
                  return {
                  component: 'cellRendererFormatter',
                  params: {value: finalValue, type: 'errorMsg'}
                  };
              },
              cellClass: (params: any) => {
      
                  if (params && params.data && params.data.authStatus.toLowerCase() === 'unauthorized') {
                  return 'status-field-disabled'
                  }
                  return null;
              }
            },
            {
              headerName: 'Value',
              headerComponentParams: {
                  irbColInfo: this.valueColInfo()
              },
              maxWidth: 150,
              suppressFiltersToolPanel: true,
              field: 'totalPortfolioValue',
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {type: 'currency'},
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'irbAgNumberColumnFilterComponent',
              minWidth: 80
            },
            {
                headerName: parent.customCategory,
                headerValueGetter: () => parent.customCategory,
                field: 'labels',
                sortable: false,
                suppressFiltersToolPanel: true,
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgSearchMultipleColumnFilterComponent',
                filterParams: (_params: any) => {
                    return {
                      values: [{name: '(none)', value: 'uncategorized'}].concat(this.pls.getDropdownOptionsForLabels(this.pls.portfolioLabels)),
                      enableHiddenSearchResults: false,
                      enableEmptySearchTerm: true,
                      noOptionsTemplate: parent.noOptionsTemplate
                    }
                },
                minWidth: 80,
                cellClass: 'dropdownSearchMultipleCell',
                cellRenderer: 'DropdownSearchMultipleRendererComponent',
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: this.pls.getDropdownOptionsForLabels(params.data.labels),
                        values: this.pls.getDropdownOptionsForLabels(this.pls.portfolioLabels),
                        width: "100%",
                        cellStyle: "labels",
                        showApplyButton: true,
                        onApply: (params: any, selectedArray: any) => {
                            parent.ats.trackClickEvent("lc_custcat");
                            parent.onCategoryDropdownChanged(params, selectedArray);
                        },
                        enableHiddenSearchResults: false,
                        enableEmptySearchTerm: true,
                        noOptionsTemplate: parent.noOptionsTemplate,
                        placeholder: "Search for an item",
                        hiddenLabelPanelTitle: parent.customCategory
                    };
                }
            },
            {
            headerName: 'Model',
            suppressFiltersToolPanel: true,
            field: 'securityModelName',
            filter: 'agSetColumnFilter',
              minWidth: 140,
            filterParams: {
                buttons: ['reset', 'apply'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                showTooltips: true,
                refreshValuesOnOpen: true,
                closeOnApply: true,
                values: (params: any) => {
                  params.success(parent.modelNames);
                }
            },
            cellClass: 'dropdownFilterCell',
            cellRenderer: 'DropdownFilterRendererComponent',
            cellRendererParams: (params: any) => {
                return {
                defaultValue: {name: params.data.securityModelName, value: params.data.securityModelName},
                values: this.getDropdownOptions(parent.modelNames),
                componentParent: this,
                colId: 'securityModelName',
                placeholder: 'none',
                onChange: (params: any, item: IDropdownItem) => {
                    parent.ats.trackClickEvent("lc_modelassign");
                    parent.onModelDropdownChanged(params, item);
                }
                };
            }
            }
            ];
            if (parent.isAutoRebalanceEnabled) {
                ret.push({
                    headerName: 'Automated',
                    suppressFiltersToolPanel: true,
                    headerComponentParams: {
                        irbColInfo: this.automatedColInfo()
                    },
                    field: 'isAutoRebalEnabled',
                    cellClass: 'nav-link-text',
                    floatingFilterComponent: 'irbInputFloatingFilterComponent',
                    filter: (parent.isAutoRebalanceEnabled ? 'IrbAgSingleSelectColumnFilterComponent' : false),
                    filterParams: {
                        buttons: ['reset'],
                        newRowsAction: 'keep',
                        suppressSorting: true,
                        cellHeight: 30,
                        values: [{label: 'Enabled', value: 1}, {label: 'Disabled', value: 0}],
                    },
                    suppressFloatingFilterButton: false,
                    cellRenderer: AutomatedRendererComponent,
                    hide: false,
                    suppressColumnsToolPanel: !parent.isAutoRebalanceEnabled,
                    minWidth: 80,
                    maxWidth:135
                });
            }
            ret.push({
              headerName: 'Restrictions',
              headerComponentParams: {
                  irbColInfo: this.restrictionsColInfo()
              },
              minWidth: 80,
              maxWidth: 140,
              suppressFiltersToolPanel: true,
              field: 'psrQty',
              cellClass: 'nav-link-text irb-cell-content-right',
              filter: 'agSetColumnFilter',
              filterParams: {
                  buttons: ['reset', 'apply'],
                  newRowsAction: 'keep',
                  suppressSorting: true,
                  cellHeight: 30,
                  closeOnApply: true,
                  refreshValuesOnOpen: true,
                  values: (params: any) => {
                  params.success(parent.restrictionNames);
                  }
              },
              cellRendererSelector: (params: any) => {
                  return this.cellRendererSelectorRestrictions(params);
              }
            });

            ret.push({
              headerName: 'Accounts',
              suppressFiltersToolPanel: true,
              field: 'acctQty',
              filter: 'agSetColumnFilter',
              filterParams: {
                  buttons: ['reset', 'apply'],
                  newRowsAction: 'keep',
                  suppressSorting: true,
                  cellHeight: 30,
                  refreshValuesOnOpen: true,
                  closeOnApply: true,
                  values: (params: any) => {
                  params.success(parent.filterAccounts);
                  }
              },
              cellClass: 'nav-link-text irb-cell-content-right',
              cellRendererSelector: (params: any) => {
                  return this.cellRendererSelectorAccounts(params);
              },
              maxWidth: 105,
              minWidth: 80,
            });

            ret.push({
                headerName: 'Gains Restriction',
                suppressFiltersToolPanel: true,
                field: 'gainsControlSetting',
                filter: 'agSetColumnFilter',
                filterParams: {
                    buttons: ['reset', 'apply'],
                    newRowsAction: 'keep',
                    suppressSorting: true,
                    cellHeight: 30,
                    refreshValuesOnOpen: false,
                    closeOnApply: true,
                    values: (params: any) => {
                        params.success(parent.gainsControlSettingOptions);
                    }
                },
                minWidth: 80,
                maxWidth: 200,
                cellClass: 'dropdownFilterCell',
                cellRenderer: 'DropdownFilterRendererComponent',
                cellRendererParams: (params: any) => {
                    return {
                        defaultValue: {name: params.data.gainsControlSetting, value: params.data.gainsControlSetting},
                        values: SettingsPortfoliosComponent.gainsControlSettingOptions,
                        placeholder: 'none',
                        refreshValuesOnOpen: true,
                        onChange: (params: any, item: IDropdownItem) => {
                            parent.ats.trackClickEvent("lc_custcat");
                            parent.onCapitalGainsDropdownChanged(params, item);
                        }
                    }
                }
            });
            ret.push({
                headerName: 'ST G/L',
                headerComponentParams: {
                    irbColInfo: this.aggregatedYTDSTColInfo()
                },
                maxWidth: 135,
                minWidth: 80,
                suppressFiltersToolPanel: true,
                field: 'shortTermGainLoss',
                cellStyle: this.cellStyleEmpty,
                cellRendererSelector: (params: any) => this.formatGainLossData(params),
                floatingFilterComponent: 'irbInputFloatingFilterComponent',
                filter: 'irbAgNumberColumnFilterComponent'
            });

            ret.push({
              headerName: 'LT G/L',
              headerComponentParams: {
                  irbColInfo: this.aggregatedYTDLTColInfo()
              },
              minWidth: 80,
              maxWidth: 135,
              suppressFiltersToolPanel: true,
              field: 'longTermGainLoss',
              cellStyle: this.cellStyleEmpty,
              cellRendererSelector: (params: any) => this.formatGainLossData(params),
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'irbAgNumberColumnFilterComponent'
            });
            
            ret.push({
              headerName: 'YTD G/L',
              headerComponentParams: {
                  irbColInfo: this.aggregatedYTDTotalColInfo()
              },
              minWidth: 80,
              maxWidth: 135,
              suppressFiltersToolPanel: true,
              field: 'totalGainLoss',
              cellStyle: this.cellStyleEmpty,
              cellRendererSelector: (params: any) => this.formatGainLossData(params),
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'irbAgNumberColumnFilterComponent'
            });

            if (parent.ENABLE_GAINS_THRESHOLD) {
                ret.push({
                    headerName: 'Gains Threshold',
                    headerComponentParams: {
                        irbColInfo: this.gainsThresholdColInfo()
                    },
                    suppressFiltersToolPanel: true,
                    field: 'gainsThresholdAmt',
                    floatingFilterComponent: 'irbInputFloatingFilterComponent',
                    filter: 'irbAgNumberColumnFilterComponent',
                    cellRenderer: 'cellRendererFormatter',
                    cellClass: "irb-cell-content-right",
                    cellRendererParams: (params: any) => {return {
                        template: (typeof params.data.gainsThresholdAmt == 'number' && params.data.gainsThresholdAmt > 0) ? `$` + this.decp.transform(params.data.gainsThresholdAmt, "1.0-0") : `--`,
                        link: (params: any) => {
                            return (params.data.gainsThresholdType === "SET_CUSTOM");
                        },
                        onClick: (function (data: any) {
                            this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data, gainsinit: true});
                        }).bind(this)
                    }},
                    maxWidth: 200,
                    minWidth: 80
                });
            }

            ret.push({
              headerName: "Notes",
              suppressFiltersToolPanel: true,
              field: "notesQty",
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: "IrbAgSingleSelectColumnFilterComponent",
              filterParams: {
                  values: [
                  { label: "With high priority notes", value: "With high priority notes" },
                  { label: "Active notes", value: "Active notes" },
                  { label: "No active notes", value: "No active notes" },
                  ],
                  buttons: ["reset"],
                  newRowsAction: "keep",
                  suppressSorting: true,
                  cellHeight: 30,
              },
              suppressFloatingFilterButton: false,
              cellClass: "nav-link-text irb-cell-content-right",
              cellRendererSelector: (params: any) => {
                  return this.cellRendererSelectorNotes(params);
              },
              minWidth: 80,
              maxWidth: 120
            });
            
            ret.push({
              headerName: 'Last Result',
              field: 'lastResult',
              suppressFiltersToolPanel: true,
              minWidth: 80,
              maxWidth: 145,
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {
                  type: 'date', format: 'MM/dd/yyyy',
                  link: (params: any) => {
                  return (params.data.authStatus !== 'Unauthorized' && params.value != null && params.data.lastResultId != null);
                  },
                  onClick: ((data: any) => {
                      parent.showLastResults(data);
                  }).bind(this)
              },
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'rangeDatePicker'
            });
            
            ret.push({
              headerName: 'Next Rebalance',
              field: 'nextRebalName',
              suppressFiltersToolPanel: true,
              maxWidth: 250,
              hide: true,
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {
                  link: (params: any) => {
                  return (params.value != null);
                  },
                  onClick: ((data: any) => {
                      parent.fireRebalanceTypeEvent(data);
                  }).bind(this)
              }
            });

            ret.push({
              headerName: 'Next Date',
              field: 'nextRebalDate',
              suppressFiltersToolPanel: true,
              minWidth: 80,
              maxWidth: 115,
              hide: true,
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {type: 'date', format: 'MM/dd/yyyy'},
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'rangeDatePicker',
            });

            ret.push({
              headerName: 'Scheduled Qty',
              suppressFiltersToolPanel: true,
              field: 'schdRebalQty',
              cellClass: 'nav-link-text irb-cell-content-right',
              cellRendererSelector: (params: any) => {
                  return this.cellRendererSelectorScheduledQty(params);
              },
              maxWidth: 160,
              hide: true
            });

            ret.push({
              headerName: 'Created On',
              field: 'createdDate',
              suppressFiltersToolPanel: true,
              minWidth: 80,
              maxWidth: 200,
              hide: true,
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'rangeDatePicker'
            });

            ret.push({
              headerName: 'Created By',
              field: 'createdBy',
              suppressFiltersToolPanel: true,
              filter: 'agSetColumnFilter',
              filterParams: {
                  buttons: ['reset', 'apply'],
                  newRowsAction: 'keep',
                  suppressSorting: true,
                  cellHeight: 30,
                  closeOnApply: true,      
                  refreshValuesOnOpen: true,
                  values: (params: any) => {
                    params.success(parent.portfolioCreatedUserList);
                  }
              },
              hide: true,
              maxWidth: 250,
              minWidth: 80
            });
            
            ret.push({
              headerName: 'Edited On',
              field: 'modifiedDate',
              suppressFiltersToolPanel: true,
              hide: true,
              cellRenderer: 'cellRendererFormatter',
              cellRendererParams: {type: 'date', format: 'MM/dd/yyyy h:mm a', displayETtext: true},
              floatingFilterComponent: 'irbInputFloatingFilterComponent',
              filter: 'rangeDatePicker',
              maxWidth: 200,
              minWidth: 80
            });

            ret.push({
              headerName: 'Edited By',
              field: 'modifiedBy',
              suppressFiltersToolPanel: true,
              
              hide: true,
              filter: 'agSetColumnFilter',
              filterParams: {
                  buttons: ['reset', 'apply'],
                  newRowsAction: 'keep',
                  suppressSorting: true,
                  cellHeight: 30,
                  closeOnApply: true,
                  refreshValuesOnOpen: true,
                  values: (params: any) => {
                  params.success(parent.portfolioEditedUserList);
                  }
              },
              maxWidth: 250,
              minWidth: 80
            });
            
            ret.push({
              // headerName: 'Quick Filters',
              headerName: 'Additional Filters',
              field: 'quickfilter',
              hide: true,
              suppressColumnsToolPanel: true,
              filter: 'customFilterToolPanel',
            },
            {
            headerName: 'Taxability',
            field: 'accountLocationType',
            hide: true,
            suppressColumnsToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                suppressMiniFilter: true,
                values: ['DEFERRED', 'ROTH', 'TAXABLE'],
                cellRenderer: (params: any) => '<div class="progTitle">' + params.value + '</div>',
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true
            }
            });
            ret.push({
            headerName: 'With tax loss results',
            field: 'taxlossResults',
            hide: true,
            suppressFiltersToolPanel: true,
            suppressColumnsToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                suppressMiniFilter: true,
                values: ['Yes', 'No'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true   
            }
            });
            ret.push({
            headerName: 'Pending Results',
            field: 'pendingResults',
            hide: true,
            suppressColumnsToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                suppressMiniFilter: true,
                values: ['Yes', 'No'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true
            }
            });
            ret.push({
            headerName: 'Assigned to MMC',
            field: 'isAssignedMMC',
            hide: true,
            suppressColumnsToolPanel: true,
            filter: 'agSetColumnFilter',
            filterParams: {
                buttons: ['reset', 'apply'],
                suppressMiniFilter: true,
                values: ['Yes', 'No'],
                newRowsAction: 'keep',
                suppressSorting: true,
                cellHeight: 30,
                closeOnApply: true
            }
            });
        return ret;
    }

    statusColInfo(){
        return `
        A portfolio's status can be incomplete or unauthorized.
        <p>Incomplete portfolios either don't have a model associated or don't have any accounts assigned to them. These portfolios can't be rebalanced, though directed trading types can be used for portfolios with no models.</p> 
        <p>Unauthorized portfolios contain at least one account that your user ID currently doesn't have permission to access. These portfolios cannot be rebalanced or edited until the account(s) that you do not have access to are removed from the portfolio. To remove the account(s), choose to edit that portfolio and remove the account(s) from the assigned accounts section.</p>
        `
    }

    valueColInfo(){
        return `
        The market value shown for the portfolio is the start of day value.
        `
    }
    automatedColInfo(){
        return `
        Set to auto-rebalance
    `
    }
    restrictionsColInfo(){
        return `
        You can set portfolio-level security restrictions. These restrictions will override any that are set for a security in the security master or in the portfolio's assigned model.
        `
    }

    aggregatedYTDSTColInfo(){
        return `
        The realized year-to-date short term gain/loss for this account is the start of day value.
        `
    }

    aggregatedYTDLTColInfo(){
        return `
        The realized year-to-date long term gain/loss for this account is the start of day value.
        `
    }

    aggregatedYTDTotalColInfo(){
        return `
        The realized year-to-date total gain/loss for this account is the start of day value.
        `
    }

    gainsThresholdColInfo(){
        return `
        <div class="block">Set a capital gains threshold to limit annual taxable gains for a portfolio.</div>
        <div class="block">After generating potential order(s) for a rebalance, iRebal will net the estimated potential gains or losses with the start-of-day year to date realized gain and loss value. If the result exceeds the gains threshold set for the portfolio, iRebal will refuse the order and notify you.</div>
        Note: For automated rebalances and scheduled rebalances, iRebal will use the start-of-day realized gain or loss value of the previous business day.
        `
    }

    portfolioFilterFormatter(filter: any) {
        if (filter === null) {
          return null;
        }
    
        return filter;
    }

    getDropdownOptions(categories: string[]) {
        let d: IDropdownItem[] = [];
        
        categories?.forEach((x: any) => {
            let item: IDropdownItem = {
                name: x, value: x
            };
            d.push(item);
        });

        return d;
    }

    getListOfValues(coliId: string) {
        let returnValue: any =  [];
        if (coliId === 'securityModelName' )
            returnValue = this.getDropdownOptions(this.modelNames);

        return returnValue;
    }

    cellRendererSelectorAutomation(params: any) {
        if (params.data) {
            return {
                component: 'cellRendererFormatter',
                params: {
                    value: params.data.isAutoRebalEnabled ? 'Enabled' : 'Disabled',
                    link: (params: any) => {
                      return (params.value != null);
                    },
                    onClick: ((data: any) => {
                      this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data, automatedRebalanceInit: true});
                    })
                }
            }
        }
    }

    cellRendererSelectorRestrictions(params: any) {
        if (params.data) {
          return {
            component: 'cellRendererFormatter',
            params: {
              value: params.data.psrQty + ' ' + "",
              link: (params: any) => {
                return (params.value != null && params.value.length > 0);
              },
              onClick: (function (data: any) {
                this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data, restrictionsinit: true});
              }).bind(this)
            }
          }
        }
    }

    cellRendererSelectorAccounts(params: any) {
        if (params.data) {
          return {
            component: 'cellRendererFormatter',
            params: {
              value: params.data.acctQty + ' ' + "",
              link: (params: any) => {
                return (params.value != null && params.value.length > 0);
              },
              onClick: (function (data: any) {
                this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data, acountsinit: true});
              }).bind(this)
            }
          }
        }
    }

    formatGainLossData(params: any) {
        if (params && params.value) {
          return {
            component: 'cellRendererFormatter',
            params: {value: params.value, type: 'currency'}
          }
        } else {
          return {
            component: 'cellRendererFormatter',
            params: {value: '--'}
          }
        }
    }

    cellStyleEmpty(params: any) {
        if (!(params && params.value)) {
            return {'text-align': 'center'};
        }
    }

    cellRendererSelectorNotes(params: any) {
        if (params.data) {
          return {
            component: 'cellRendererFormatter',
            params: {
              value: params.data.notesQty + ' ' + "",
              link: (params: any) => {
                return (params.value != null && params.value.length > 0);
              },
              onClick: (function (data: any) {
                this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {data: data, notesinit: true});
              }).bind(this)
            }
          }
        }
    }

    cellRendererSelectorScheduledQty(params: any) {
        if (params.data) {
          return {
            component: 'cellRendererFormatter',
            params: {
              value: params.data.schdRebalQty + ' ' + "",
              link: (params: any) => {
                return (params.value != null && params.value.length > 0);
              },
              onClick: (function (data: any) {    
                this.as.fireEvent(IrbClientsEvents.SHOW_EDIT_PORTFOLIO, {
                  data: data,
                  scheduledRebalancesInit: true
                });
              }).bind(this)
            }
          }
        }
    }

    openNewItemCategoryFlow(dataParam: any) {
        this.as.setToLocal("LAST_TAB_INDEX", 2);
        this.as.fireEvent(IrbSettingsEvents.SHOW, dataParam);
    }

    getColumnLimits() {
      return {
        columnLimits: [
          { key: 'portfolioName', minWidth: 160 },
          { key: 'status', minWidth: 100 },
          { key: 'labels', minWidth: 120 },
          { key: 'totalPortfolioValue', minWidth: 113 },
          { key: 'isAutoRebalEnabled', minWidth: 107 },
          { key: 'psrQty', minWidth: 118 },
          { key: 'acctQty', minWidth: 90 },
          { key: 'gainsControlSetting', minWidth: 160 },
          { key: 'totalGainLoss', minWidth: 110 },
          { key: 'gainsThresholdAmt', minWidth: 142 },
          { key: 'notesQty', minWidth: 85 },
          { key: 'lastResult', minWidth: 100 },
          { key: 'nextRebalName', minWidth: 200 },
          { key: 'nextRebalDate', minWidth: 85 },
          { key: 'schdRebalQty', minWidth: 112 },
          { key: 'createdDate', minWidth: 170 },
          { key: 'createdBy', minWidth: 140 },
          { key: 'modifiedDate', minWidth: 170 },
          { key: 'modifiedBy', minWidth: 140 }
        ]
      }
    }
}
